import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from './auth.service';

@Pipe({
  name: 'hasWPermission'
})
export class HasWPermissionPipe implements PipeTransform {

  constructor(
    private authService: AuthService
  ) {

  }

  transform(value: string): boolean {
    return this.authService.havePermission(value, 'W');
  }

}
